import { httpRequest } from 'http'

import { sendErrorNotification } from 'helpers/web_to_client'
import moment from 'moment'
import { MAX_SET_TIMEOUT_VALUE } from 'constants'
import { push } from 'react-router-redux'
import { SHOP_CONGRATULATIONS, SHOP_ERROR } from 'urls'
import { ErrorIds, ServerErrorIds } from 'containers/ShopView/containers/ShopErrorScreen/constants'
import { formatMessage } from 'locale'
import { errors } from 'containers/ShopView/constants'

export const SHOP_PRODUCTS_LOAD_REQUEST = 'shop/products/REQUEST'
export const SHOP_PRODUCTS_LOAD_SUCCESS = 'shop/products/SUCCESS'
export const SHOP_PRODUCTS_LOAD_ERROR = 'shop/products/ERROR'

export const SHOP_STATUS_LOAD_REQUEST = 'shop/status/REQUEST'
export const SHOP_STATUS_LOAD_SUCCESS = 'shop/status/SUCCESS'
export const SHOP_STATUS_LOAD_ERROR = 'shop/status/ERROR'

export const SHOP_PURCHASE_REQUEST = 'shop/purchase/REQUEST'
export const SHOP_PURCHASE_SUCCESS = 'shop/purchase/SUCCESS'
export const SHOP_PURCHASE_ERROR = 'shop/purchase/ERROR'

export function shopProductsRequestStart() {
    return {
        type: SHOP_PRODUCTS_LOAD_REQUEST,
    }
}

export function shopProductsRequestSuccess(data) {
    return {
        type: SHOP_PRODUCTS_LOAD_SUCCESS,
        payload: data,
    }
}

export function shopProductsRequestError(errorData, errorMessage) {
    sendErrorNotification(errorMessage ? {
        ...errorData,
        errorMessage,
    } : errorData)

    return {
        type: SHOP_PRODUCTS_LOAD_ERROR,
        payload: errorData,
    }
}

export const shopStatusRequestStart = () => ({
    type: SHOP_STATUS_LOAD_REQUEST,
})

export const shopStatusRequestSuccess = (data) => ({
    type: SHOP_STATUS_LOAD_SUCCESS,
    payload: data,
})

export function shopStatusRequestError(errorData, errorMessage) {
    sendErrorNotification(errorMessage ? {
        ...errorData,
        errorMessage,
    } : errorData)

    return {
        type: SHOP_STATUS_LOAD_ERROR,
        payload: errorData,
    }
}

export const shopPurchaseStart = () => ({
    type: SHOP_PURCHASE_REQUEST,
})

export const shopPurchaseSuccess = (product_id) => ({
    type: SHOP_PURCHASE_SUCCESS,
    payload: product_id,
})

export function shopPurchaseError(errorData, errorMessage) {
    sendErrorNotification(errorMessage ? {
        ...errorData,
        errorMessage,
    } : errorData)

    return {
        type: SHOP_PURCHASE_ERROR,
        payload: errorData,
    }
}

let shopProductsExpireTimeoutId
export function requestShopProducts() {
    return async (dispatch, getState) => {
        const state = getState()
        if (state.shop.productsLoading) {
            return
        }

        clearInterval(shopProductsExpireTimeoutId)
        dispatch(shopProductsRequestStart())

        httpRequest('/game_api/shop_products')
        .then(
            data => {
                // set timeout to update status after expiration
                if (data.meta.enabled) {
                    const expiration = data.meta.end_datetime - moment().valueOf()
                    if (expiration > 0 && expiration < MAX_SET_TIMEOUT_VALUE) {
                        shopProductsExpireTimeoutId = setTimeout(() => {
                            dispatch(requestShopProducts())
                        }, expiration + 1000)
                    }
                }

                dispatch(shopProductsRequestSuccess(data))
            },
            errorData => {
                if (errorData.statusCode === 403) {
                    dispatch(shopProductsRequestError(errorData, formatMessage(errors[ErrorIds.NOT_CLAN_MEMBER])))
                } else {
                    dispatch(shopProductsRequestError(errorData))
                }
            },
        )
    }
}

export function purchaseShopProduct(product_id) {
    return async (dispatch, getState) => {
        const state = getState()
        if (state.shop.purchaseInProgress) {
            return
        }

        dispatch(shopPurchaseStart())

        httpRequest('/game_api/purchase_product', 'POST', { product_id })
        .then(
            () => {
                dispatch(shopPurchaseSuccess(product_id))
                dispatch(push(SHOP_CONGRATULATIONS(product_id)))
            },
            (errorData) => {
                switch (errorData.errorMessage) {
                case ServerErrorIds.NO_CURRENT_ACTION:
                    dispatch(shopPurchaseError(errorData, formatMessage(errors[ErrorIds.EXPIRED])))
                    dispatch(push(SHOP_ERROR(ErrorIds.EXPIRED)))
                    return
                case ServerErrorIds.NO_SUCH_PRODUCT:
                case ServerErrorIds.PRODUCT_CANNOT_PURCHASED:
                case ServerErrorIds.PRODUCT_ALREADY_PURCHASED:
                case ServerErrorIds.FAILED_PURCHASE_PRODUCT:
                case ServerErrorIds.FAILED_SUCCESS_RETRY_TRANSACTION:
                default:
                    if (errorData.statusCode === 403) {
                        dispatch(shopPurchaseError(errorData, formatMessage(errors[ErrorIds.NOT_CLAN_MEMBER])))
                    } else {
                        dispatch(shopPurchaseError(errorData, formatMessage(errors[ErrorIds.INTERNAL_ERROR])))
                        dispatch(push(SHOP_ERROR(ErrorIds.INTERNAL_ERROR)))
                    }
                }
            },
        )
    }
}

let shopStatusExpireTimeoutId
export function requestShopStatus() {
    return async (dispatch, getState) => {
        const state = getState()
        if (state.shop.statusLoading) {
            return
        }

        clearInterval(shopStatusExpireTimeoutId)
        dispatch(shopStatusRequestStart())

        httpRequest('/game_api/shop_info')
        .then(
            data => {
                // set timeout to update status after expiration
                if (data.enabled) {
                    const expiration = data.end_datetime - moment().valueOf()
                    if (expiration > 0 && expiration < MAX_SET_TIMEOUT_VALUE) {
                        shopStatusExpireTimeoutId = setTimeout(() => {
                            dispatch(requestShopStatus())
                        }, expiration + 1000)
                    }
                }

                dispatch(shopStatusRequestSuccess(data))
            },
            errorData => {
                if (errorData.statusCode === 403) {
                    dispatch(shopStatusRequestError(errorData, formatMessage(errors[ErrorIds.NOT_CLAN_MEMBER])))
                } else {
                    dispatch(shopStatusRequestError(errorData))
                }
            },
        )
    }
}



// WEBPACK FOOTER //
// ./state/actions/shop.js